module.exports = {
  "/": {
    "success": {
      "default": [
        "DIRECTORY_LOADED"
      ]
    },
    "error": [
      "DIRECTORY_LOAD_FAILURE"
    ]
  },
  "/member/:username": {
    "success": {
      "academy tab": [
        "PROFILE_LOADED",
        "ACADEMY_TAB_LOADED"
      ],
      "community tab": [
        "PROFILE_LOADED",
        "COMMUNITY_TAB_LOADED",
        "COMMUNITY_STATS_LOADED"
      ],
      "private profile": [
        "PRIVATE_PROFILE_LOADED"
      ]
    },
    "error": [
      "PROFILE_LOAD_FAILURE"
    ]
  },
  "/edit": {
    "success": {
      "default": [
        "EDIT_PROFILE_LOADED"
      ]
    },
    "error": [
      "EDIT_PROFILE_LOAD_FAILURE"
    ]
  }
};